import * as React from 'react';
import { headingSectionIndexContext } from './context';
export function HeadingSectionIndexProvider(props) {
    var index = props.index, children = props.children;
    return (React.createElement(headingSectionIndexContext.Provider, { value: index }, children));
}
